<mat-card class="col-12 notifies">
  <div class="col-12 pl-0 mb-2 title-notify">
    <strong>Notifications</strong>
  </div>
  <ng-container *ngIf="loadingNotifictions">
    <mat-spinner style="margin: 0 auto;width: 60px !important;
    height: 60px !important;"></mat-spinner>
  </ng-container>
  <ng-container *ngIf="!loadingNotifictions">
    <div
      class="row"
      *ngFor="let notification of notifications; let i = index"
    >
      <div class="col-12 cursor-p">
        <span class="text-notification pt-1 pb-1">{{
          notification.NotificationApp.message
        }}</span>
        <div class="container-date">
          <span class="text-date-notification">{{
            notification.createdAt | date: 'MM/dd/yyyy hh:mm a':'OOOO'
          }}</span>
        </div>
      </div>
      <hr class="hr" />
    </div>
    <div class="row" *ngIf="notifications.length == 0">
      <div class="col-12 cursor-p">
        <span class="text-notification pt-1 pb-1"
          >Currently there are no pending notifications
          </span
        >
      </div>
      <hr class="hr" /></div
  ></ng-container>
</mat-card>
